<template>
  <Modal :open="displayModal" title="Modify User's Permissions" size="small" :showEscapeButton="true"
    :showAcceptButton="true" :showDangerButton="false" acceptButtonText="Update Permissions"
    :acceptButtonProgress="loading" @close="displayModal = false" @onSuccess="modifyPermissions" ref="modal">
    <div class="grid grid-cols-1 gap-4">
      <div>
        <label for="user_permission" class="block text-sm font-medium text-gray-700 mb-1">Select Role</label>
        <select id="user_permission" name="user_permission"
          class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md" v-model="data.role">
          <option value="videographer">Videographer</option>
          <option value="media_purchaser">Media Purchaser</option>
          <option value="media_producer">Media Producer</option>
          <option value="administrator">Administrator</option>
          <option value="superadministrator">Super Administrator</option>
        </select>
      </div>

      <div v-if="data.role == 'media_purchaser' || data.role == 'media_producer'">
        <label for="user_network" class="block text-sm font-medium text-gray-700">Network</label>
        <label class="dropdown_wrap">
          <select class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
            v-model="data.network.id">
            <option v-for="network in networks" :value="network.id" v-bind:key="network.id">{{ network.name }}</option>
          </select>
        </label>
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      stringerPercentModal: false,
      displayModal: false,
      data: {},
      loading: false,
      networks: []
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function () {
        this.getNetworks();
        this.$eventBus.$on(
          "admin-user-change-permissions-modal-open",
          this.open
        );
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-user-change-permissions-modal-open", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open(data) {
      this.displayModal = true;
      this.data = data;
    },
    async getNetworks() {
      let response = await this.$http.get(
        Config.apiPath + "/api/v2/admin/networks"
      );
      this.networks = response.data;
    },
    async modifyPermissions() {
      this.loading = true;
      let res = await this.$http.post(
        Config.apiPath +
        "/api/v2/admin/users/" +
        this.data.id +
        "/permissions",
        { role: this.data.role, network_id: this.data.network.id }
      );

      if (res.status == 200) {
        this.loading = false;
        this.displayModal = false;

        this.addToastMessage({
          title: "Success",
          text: this.data.name + "'s role was updated.",
          type: "success"
        });
      } else {
        this.loading = false;

        this.addToastMessage({
          title: "Whoops!",
          text:
            "An error was encountered while updating " +
            this.data.name +
            "'s role.",
          type: "error"
        });
      }
    }
  }
};
</script>
